module.exports = __webpack_public_path__ + "static/img/066_TO8_1630.4fb5a5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/066_TO8_1630.jpg
// module id = Qhlq
// module chunks = 0